import React from 'react';

const RsvpPage = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#000',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '60px 20px',
      boxSizing: 'border-box',
    }}>

      {/* Cover */}
      <img
        src="https://pub-9117c3d26d7c48be97349efbfc97f1de.r2.dev/cover_micandcam.jpeg"
        alt="Bienvenue au Festival Mic & Cam"
        style={{
          width: '100%',
          maxWidth: '800px',
          borderRadius: '12px',
          display: 'block',
        }}
      />

      {/* Title */}
      <p style={{
        marginTop: '28px',
        fontFamily: 'Helvetica Neue, Arial, sans-serif',
        fontSize: 'clamp(18px, 4vw, 28px)',
        fontWeight: '900',
        letterSpacing: '2px',
        color: '#FFE600',
        textAlign: 'center',
        textTransform: 'uppercase',
      }}>
        MIC &amp; CAM DISPONIBLE CE VENDREDI À MINUIT
      </p>

      {/* Pre-save button */}
      <a
        href="https://ffm.to/1pvexpv"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'inline-block',
          marginTop: '28px',
          padding: '14px 36px',
          background: '#fff',
          color: '#000',
          fontFamily: 'Helvetica Neue, Arial, sans-serif',
          fontSize: '14px',
          fontWeight: '700',
          letterSpacing: '1px',
          textDecoration: 'none',
          borderRadius: '6px',
        }}
      >
        PRE-SAVE L'ALBUM
      </a>

      {/* YouTube embed */}
      <div style={{
        width: '100%',
        maxWidth: '800px',
        marginTop: '48px',
        aspectRatio: '16/9',
        borderRadius: '12px',
        overflow: 'hidden',
      }}>
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/8_5ybmrI044"
          title="SCAM"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ display: 'block' }}
        />
      </div>

      {/* Streaming button */}
      <a
        href="https://ffm.to/scam"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'inline-block',
          marginTop: '24px',
          marginBottom: '60px',
          padding: '14px 36px',
          background: '#fff',
          color: '#000',
          fontFamily: 'Helvetica Neue, Arial, sans-serif',
          fontSize: '14px',
          fontWeight: '700',
          letterSpacing: '1px',
          textDecoration: 'none',
          borderRadius: '6px',
        }}
      >
        ÉCOUTER SUR TOUTES LES PLATEFORMES
      </a>

    </div>
  );
};

export default RsvpPage;
